/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_SleepInputs */

const en_us2_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep`)
};

const pt_br2_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono`)
};

const es_419_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sueño`)
};

const pt_pt2_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono`)
};

const fr_fr2_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommeil`)
};

const de_de2_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlaf`)
};

const it_it2_plan_build_grounding_sleep = /** @type {(inputs: Plan_Build_Grounding_SleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonno`)
};

/**
* | output |
* | --- |
* | "Sleep" |
*
* @param {Plan_Build_Grounding_SleepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_sleep = /** @type {((inputs?: Plan_Build_Grounding_SleepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_SleepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_sleep(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_sleep(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_sleep(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_sleep(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_sleep(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_sleep(inputs)
	return en_us2_plan_build_grounding_sleep(inputs)
});
export { plan_build_grounding_sleep as "plan-build.grounding_sleep" }